<template>
  <div class="enterprise-add">
    <p class="title">企业客户还车</p>
    <div class="steps-wrapper">
      <ReturnCarStep :fixedStepIndex="originStep" :currentStepIndex="currentStep" :steps="stepList" @change="handelStepClick" />
    </div>
    <div>
      <keep-alive>
        <component
          :is="currentComponent"
          :orderId="queries.orderId"
          @returnCarBeginCompleted="handleReturnCarBeginCompleted"
          @checkoutCarCompleted="handleCheckoutCarCompleted"
        />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import ReturnCarStep from '../components/returnCarStep.vue' // 步骤条
import CheckoutCarAdd from './components/checkoutCar/index.vue' // 入库验车
import CheckoutExpenseAdd from './components/checkoutExpense/index.vue' // 费用结算
// 订单核算
import CheckoutOrderAdd from './components/checkoutOrder/index.vue'
import ReturnCarBeginAdd from './components/returnCarBegin/index.vue' // 发起退车

import CheckoutCarDetail from '@/pages/cars/returnCar/detail/components/checkoutCar/index.vue' // 入库验车
import CheckoutExpenseDetail from '@/pages/cars/returnCar/detail/components/checkoutExpense/index.vue'
import CheckoutOrderDetail from '@/pages/cars/returnCar/detail/components/checkoutOrder/index.vue'
import ReturnCarBeginDetail from '@/pages/cars/returnCar/detail/components/returnCarBegin/index.vue'

import { getOrderDetail } from '@/api/domain/returnLease'
import { ENTERPRISE_RETURN_CAR_STEPS, ORDER_STATES, ORDER_TYPES } from '@/pages/cars/returnCar/config'
import WindowCommunication from '@/utils/windowCommunication'

export default {
  provide() {
    return {
      orderType: ORDER_TYPES.enterprise.value,
      orderData: this.orderData,
    }
  },
  data() {
    return {
      originStep: -1,
      currentStep: -1,
      stepList: ENTERPRISE_RETURN_CAR_STEPS,
      orderData: {},
      queries: JSON.parse(decodeURIComponent(this.$route.query.query || '{}')),
    }
  },
  computed: {
    currentComponent() {
      if (this.currentStep === 0) {
        return this.currentStep === this.originStep ? 'ReturnCarBeginAdd' : 'ReturnCarBeginDetail'
      }
      if (this.currentStep === 1) {
        return this.currentStep === this.originStep ? 'CheckoutCarAdd' : 'CheckoutCarDetail'
      }
      if (this.currentStep === 2) {
        return this.currentStep === this.originStep ? 'CheckoutOrderAdd' : 'CheckoutOrderDetail'
      }
      return ''
    },
  },
  methods: {
    async init() {
      const { orderId } = this.queries

      if (orderId) {
        await this.getOrderDetail()
      }

      this.locateStepByOrderData()
    },
    updateQueries() {
      this.queries = JSON.parse(decodeURIComponent(this.$route.query.query || '{}'))
    },
    locateStepByOrderData() {
      const { state } = this.orderData
      let step = 0

      if (state === ORDER_STATES.returnCarCheckoutWaiting.value) {
        step = 1
      } else if (state === ORDER_STATES.checkoutOrderWaiting.value) {
        step = 2
      } else if (state === ORDER_STATES.closed.value) {
        step = 3
      }

      this.originStep = step
      this.currentStep = step
      this.sendMessage()
    },
    handelStepClick(stepIndex) {
      if (stepIndex <= this.originStep) {
        this.currentStep = stepIndex
      }
    },
    async getOrderDetail(orderId) {
      const _orderId = orderId || this.queries.orderId

      if (_orderId) {
        let res

        try {
          res = await getOrderDetail({
            orderId: parseInt(_orderId),
          })
        } catch (err) {
          console.error(err)
        }

        if (!res) return

        const { code, data } = res
        if (code === 1) {
          Object.keys(data).forEach((key) => {
            this.orderData[key] = data[key]
          })
        }
      }
    },
    next() {
      if (this.currentStep < this.stepList.length - 1) {
        this.originStep += 1
        this.currentStep += 1
      }
    },
    // 发起退车提交成功后直接进入入库验车
    handleReturnCarBeginCompleted({ id, orderId }) {
      this.sendMessage()
      const queryObj = {
        id,
        orderId,
        scene: this.queries.scene,
      }
      const queryStr = JSON.stringify(queryObj)
      const query = {
        query: queryStr,
      }

      this.$router.replace({
        query,
      }, async () => {
        this.updateQueries()
        await this.getOrderDetail()
        // this.next()
        this.locateStepByOrderData()
      })
    },
    sendMessage() {
      // 跨页面通信 通知签约提车车辆状态信息刷新
      const query = JSON.parse(decodeURIComponent(this.$route.query.query || '{}'))
      if (query.scene) {
        const communication = new WindowCommunication('person_sign_contract')
        communication.send({
          type: 'unavailable_message',
          data: query.orderId,
        })
      }
    },
    // 入库验车提交成功后直接进入退车核算
    async handleCheckoutCarCompleted() {
      await this.getOrderDetail()
      this.next()
    },
  },
  created() {
    this.init()
  },
  components: {
    ReturnCarStep,
    ReturnCarBeginAdd,
    CheckoutCarAdd,
    CheckoutOrderAdd,
    CheckoutExpenseAdd,
    ReturnCarBeginDetail,
    CheckoutCarDetail,
    CheckoutOrderDetail,
    CheckoutExpenseDetail,
  },
}
</script>

<style lang="scss" scoped>
  .title {
    width: 100%;
    height: 40px;
    line-height: 40px;
    padding: 0 12px;
    font-weight: 600;
    font-size: 16px;
    color: #323233;
    margin-bottom: 14px;
  }
  .steps-wrapper {
    margin: 0 24px;
    padding: 24px 0 24px;
  }
</style>
